/**
 * Identificadores únicos, también fuera de contexto seguro.
 *
 * `crypto.randomUUID()` SOLO existe en contexto seguro (HTTPS o localhost). Al
 * abrir la app desde el móvil contra la IP de la red por HTTP no está definida,
 * y la llamada revienta con un TypeError nada más pulsar "Crear nota" — que es
 * exactamente el fallo que apareció al probarla desde el teléfono.
 *
 * En producción, servida por HTTPS, se usa la nativa. El resto son escalones
 * hacia abajo para que la app nunca se caiga por esto.
 */
export function identificador(): string {
  const cripto = globalThis.crypto as Crypto | undefined;

  if (typeof cripto?.randomUUID === 'function') {
    return cripto.randomUUID();
  }

  // getRandomValues SÍ está disponible en contexto no seguro, así que la
  // aleatoriedad sigue siendo buena; solo se construye el UUID a mano.
  if (typeof cripto?.getRandomValues === 'function') {
    const bytes = cripto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6]! & 0x0f) | 0x40; // versión 4
    bytes[8] = (bytes[8]! & 0x3f) | 0x80; // variante
    const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(
      16,
      20,
    )}-${hex.slice(20)}`;
  }

  // Último recurso. Estos identificadores solo tienen que ser únicos dentro de
  // un móvil, no impredecibles, así que sirve — pero si se llega aquí es que el
  // navegador es muy raro y conviene saberlo.
  console.warn('[identificador] sin crypto: usando un generador débil');
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}-${Math.random()
    .toString(36)
    .slice(2, 10)}`;
}
